import {connect} from 'react-redux'
import * as messengersActions from "../actions/messengersActions";
import DefineAvailabilityDialog from "../../Components/Toolbars/TopToolbar/DefineAvailabilityDialog/DefineAvailabilityDialog";
import _ from "lodash";

const mapStateToProps = (store) => {
    return {
        onShift: store.usersReducer.users.filter(user => !user.isHidden && _.get(user, "profiles.messenger.isCurrentlyOnShift"))
    };
};

const mapDispatchToProps = {
    updateMessengerAvailability: messengersActions.updateMessengerAvailabilityAction
};

const DefineAvailabilityDialogContainer = connect(mapStateToProps, mapDispatchToProps)(DefineAvailabilityDialog);

export default DefineAvailabilityDialogContainer;